const UserInputsHarnessPage = require('./UserInputsHarnessPage');
const UserSearchFilterHarnessPage = require('./UserSearchFilterHarnessPage');

module.exports = [
    {
        path: '/__dev__/user-inputs',
        exact: true,
        component: UserInputsHarnessPage
    },
    {
        path: '/__dev__/user-search-filter',
        exact: true,
        component: UserSearchFilterHarnessPage
    }
];
